import React, { Component } from 'react'
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ModalImage from 'react-modal-image';
import Modal from './Modal';

export default class Home extends Component {
    render() {
      
        return (
            <div className="homepage">
              <div className="home" id="#promo">
                    <div className="text-home">
                        <h1> Save on your next visit! </h1>
                        <p>Visit our Yelp! page for exclusive monthly offers!</p>
                        <a className="btn-red btn-info btn-lg"   href="https://www.yelp.com/biz/cunhas-country-store-half-moon-bay-2">Get Deal!</a>
                    </div>
                </div>
              
       
                <div className="home-2" style={{margin:'auto', paddingBottom:'40px'}}>

                    <h1 style={{paddingTop:'40px'}}> Welcome to cunha's country store! </h1>
                    <p> Cunha's country store was found by the Cunha family in 1924, now a landmark to the small town of
                        half moon bay. old-fashioned, family-run and known for a personal customer experience.
                    </p>
                
                </div>
                <div className="home-3" style={{margin:'auto', paddingBottom:'40px'}}>

                    <h1 style={{paddingTop:'40px',paddingBottom:'40px'}}> What's Inside?</h1>
                    <Container>
                        <Row>
                            <Col md={4}>
                            <i class="fa fa-shopping-basket" style={{fontSize:'42px', color:'#0cf'}}></i>
                            <h2>Grocery</h2>
                            <p>Local dairy, eggs, produce, bread, cheeses, ice cream, and much more.</p>
                            </Col>
                            <Col md={4}>
                            <i class="fas fa-utensils" style={{fontSize:'42px', color:'#0cf'}} ></i>
                            <h2>Deli</h2>
                            <p>Serving top of the line Boar's Head subs since the 1900s.</p>
                            </Col>
                            <Col md={4}>
                            <i class="fa fa-coffee" style={{fontSize:'42px', color:'#0cf'}}></i>
                            <h2>Espresso</h2>
                            <p>Local organic brewed espresso from Jeremiah's Pick Coffee.</p>
                            </Col>
                            <Col md={4}>
                            <i class="fas fa-tshirt" style={{fontSize:'42px', color:'#0cf'}}/>
                            <h2>Clothing</h2>
                            <p>Half moon bay t-shirts, hoodies, jackets, and hats; from children to adults.</p>
                            </Col>
                            <Col md={4}>
                            <i class="fa fa-beer"style={{fontSize:'42px', color:'#0cf'}}/>
                            <h2>Wines & Spirits</h2>
                            <p>Rare and exclusive wines, premium alchohol, and hundreds of craft beers.</p>
                            </Col>
                            <Col md={4}>
                            <i class="fa fa-globe"style={{fontSize:'42px', color:'#0cf'}}/>
                            <h2>International</h2>
                            <p>International grocery from the UK, Ireland, Italy, Portugal, and Greece.</p>
                            </Col>
                        </Row>
                    </Container>


                    <div className="home-2" style={{margin:'auto', paddingBottom:'40px'}}>

                        <h1 style={{paddingTop:'40px',paddingBottom:'20px'}}> 
                        Store hours<i class="fa fa-calendar" style={{width:'100px', color:'#0cf'}}/>
                        </h1>
                        
                        <h4> Monday - Friday: 8 AM - 8 PM <br></br>
                            Saturday: 8 AM - 8 PM <br></br>
                            Sunday: 8 AM - 7 PM
                        </h4>
                        </div>
             <div className="home-3" style={{margin:'auto', paddingBottom:'40px'}}>
                <h1>Gallery</h1>
             <Container> 
                 <Row>
                     <Col md={4}>
                <ModalImage
                    small="http://cunhacountrystore.com/assets/img/sand2.png"
                    large="http://cunhacountrystore.com/assets/img/sand2.png"
                    alt="Hot Pastrami with the works on a French Roll"
                />;
                    </Col>
                    <Col md={4}>
                <ModalImage
                    small="http://cunhacountrystore.com/assets/img/turkey.png"
                    large="http://cunhacountrystore.com/assets/img/turkey.png"
                    alt="Turkey Bacon Avocado with the works on a Dutch Crunch Roll"
                />;
                    </Col>
                    <Col md={4}>
                <ModalImage
                    small="http://cunhacountrystore.com/assets/img/sand.png"
                    large="http://cunhacountrystore.com/assets/img/sand.png"
                    alt="Roast beef and Swiss with the works on a Dutch Crunch Roll"
                />;
                    </Col>
                </Row>
                </Container>
             </div> 
               
                </div>
            
                   
            </div>
        )
    }
}
    {/*      <div className="home" style={{ margin:'auto'}}>
                    <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100 "
                        src="/img/product-4.png"
                        alt="First slide"
                        />
                     <Carousel.Caption style={{color:'white'}}>
                        <p style={{fontSize:'1rem'}}>Google Pixel 3 - Silver - 128GB</p>
                        <Link to="/" style={{textDecoration:'none', color:'white', fontSize:'1rem'}}> Check Availability</Link>
                        </Carousel.Caption>
                    </Carousel.Item>
                    
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src="/img/product-2.png"
                        alt="Third slide"
                        />

                        <Carousel.Caption style={{color:'black'}}>
                        <h3 className="slide-label">Second slide label</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src="/img/product-3.png"
                        alt="Third slide"
                        />

                        <Carousel.Caption style={{color:'black'}}>
                        <h3 className="slide-label">Third slide label</h3>
                        <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    </Carousel> 
                   
                     </div>
        
        
        
        
        
        <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src="/img/product-4.png"
                        alt="First slide"
                        />
                        <Carousel.Caption>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100 d-lg-2"
                        src="/img/product-2.png"
                        alt="Third slide"
                        />

                        <Carousel.Caption>
                        <h3>Second slide label</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src="/img/product-3.png"
                        alt="Third slide"
                        />

                        <Carousel.Caption>
                        <h3>Third slide label</h3>
                        <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    </Carousel> */}